/**
 * @generated SignedSource<<b5a64dff97fcdec75241d182f22448c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AgentsRendererQuery$variables = {
  organizationSlug: string;
};
export type AgentsRendererQuery$data = {
  readonly organization: {
    readonly " $fragmentSpreads": FragmentRefs<"Agents_organization">;
  } | null;
};
export type AgentsRendererQuery = {
  response: AgentsRendererQuery$data;
  variables: AgentsRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationSlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "organizationSlug"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentsRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Agents_organization"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentsRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uuid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "91007c034aff18b9310d994f934bde65",
    "id": null,
    "metadata": {},
    "name": "AgentsRendererQuery",
    "operationKind": "query",
    "text": "query AgentsRendererQuery(\n  $organizationSlug: ID!\n) {\n  organization(slug: $organizationSlug) {\n    ...Agents_organization\n    id\n  }\n}\n\nfragment Agents_organization on Organization {\n  id\n  uuid\n  slug\n}\n"
  }
};
})();

(node as any).hash = "a502c899d88c88d4ac2ab1d9a15296bd";

export default node;
